import React from "react";

export const partnerLicenceSagaActionTypes = {
  callPartnerLicenceListSaga: "callPartnerLicenceListSaga",
  callUpdatePartnerLicenceSaga: "callUpdatePartnerLicenceSaga",
  callDeletePartnerLicenceSaga: "callDeletePartnerLicenceSaga",
  callAddPartnerLicenceSaga: "callAddPartnerLicenceSaga",
};


export const getPartnerLicenceListSagaAction: (ID: number) => {
  type: string;
  payload: {
    ID: number;
  };
} = (ID: number) => {
  return {
    type: partnerLicenceSagaActionTypes.callPartnerLicenceListSaga,
    payload: {
      ID: ID,
    },
  };
};

export type AddPartnerLicenceDetailsType = {
  ID: number,
  license_type: string,
  license_count: number,
  points: number,
  comments: string,
};

export const addPartnerLicenceListSagaAction: (data: AddPartnerLicenceDetailsType) => {
  type: string;
  payload: AddPartnerLicenceDetailsType;
} = (data: AddPartnerLicenceDetailsType) => {
  return {
    type: partnerLicenceSagaActionTypes.callAddPartnerLicenceSaga,
    payload: data,
  };
};

export type updatePartnerLicenceListPayloadType = {
  ID: number;
  license_type: string,
  license_count: number,
  points: number,
  comments: string,
};

export const updatePartnerLicenceListSagaAction: (partnerLicence: updatePartnerLicenceListPayloadType) => {
  type: string;
  payload: {
    partnerLicence: updatePartnerLicenceListPayloadType;
  };
} = (partnerLicence: updatePartnerLicenceListPayloadType) => {
  return {
    type: partnerLicenceSagaActionTypes.callUpdatePartnerLicenceSaga,
    payload: {
      partnerLicence: partnerLicence,
    },
  };
};

export type deletePartnerLicenceListPayloadType = {
  ID: number;
  setOpen: React.Dispatch<React.SetStateAction<boolean>>;
};

export const deletePartnerLicenceListSagaAction: (
  payload: deletePartnerLicenceListPayloadType
) => {
  type: string;
  payload: {
    ID: number;
    setOpen: React.Dispatch<React.SetStateAction<boolean>>;
  };
} = (payload: deletePartnerLicenceListPayloadType) => {
  return {
    type: partnerLicenceSagaActionTypes.callDeletePartnerLicenceSaga,
    payload: payload,
  };
};



